// 폰트 동적 로드
const loadFonts = () => {
  const fontFaces = [
    {
      family: 'Pretendard',
      src: `${process.env.PUBLIC_URL || ''}/fonts/Pretendard/PretendardVariable.woff2`,
      weight: '100 900',
      style: 'normal',
    },
    {
      family: 'SUIT',
      src: `${process.env.PUBLIC_URL || ''}/fonts/SUIT-ttf/SUIT-Thin.ttf`,
      weight: 100,
    },
    {
      family: 'SUIT',
      src: `${process.env.PUBLIC_URL || ''}/fonts/SUIT-ttf/SUIT-ExtraLight.ttf`,
      weight: 200,
    },
    {
      family: 'SUIT',
      src: `${process.env.PUBLIC_URL || ''}/fonts/SUIT-ttf/SUIT-Light.ttf`,
      weight: 300,
    },
    {
      family: 'SUIT',
      src: `${process.env.PUBLIC_URL || ''}/fonts/SUIT-ttf/SUIT-Regular.ttf`,
      weight: 400,
    },
    {
      family: 'SUIT',
      src: `${process.env.PUBLIC_URL || ''}/fonts/SUIT-ttf/SUIT-Medium.ttf`,
      weight: 500,
    },
    {
      family: 'SUIT',
      src: `${process.env.PUBLIC_URL || ''}/fonts/SUIT-ttf/SUIT-SemiBold.ttf`,
      weight: 600,
    },
    {
      family: 'SUIT',
      src: `${process.env.PUBLIC_URL || ''}/fonts/SUIT-ttf/SUIT-Bold.ttf`,
      weight: 700,
    },
    {
      family: 'SUIT',
      src: `${process.env.PUBLIC_URL || ''}/fonts/SUIT-ttf/SUIT-ExtraBold.ttf`,
      weight: 800,
    },
    {
      family: 'SUIT',
      src: `${process.env.PUBLIC_URL || ''}/fonts/SUIT-ttf/SUIT-Heavy.ttf`,
      weight: 900,
    },
    {
      family: 'RedHatDisplay',
      src: `${process.env.PUBLIC_URL || ''}/fonts/RedHatDisplay/RedHatDisplay-SemiBold.ttf`,
      weight: 600,
    },
    {
      family: 'RedHatDisplay',
      src: `${process.env.PUBLIC_URL || ''}/fonts/RedHatDisplay/RedHatDisplay-Bold.ttf`,
      weight: 700,
    },
    {
      family: 'RedHatDisplay',
      src: `${process.env.PUBLIC_URL || ''}/fonts/RedHatDisplay/RedHatDisplay-Regular.ttf`,
      weight: 400,
    },
    {
      family: 'RedHatDisplay',
      src: `${process.env.PUBLIC_URL || ''}/fonts/RedHatDisplay/RedHatDisplay-Medium.ttf`,
      weight: 500,
    },
  ];

  fontFaces.forEach((font) => {
    // Variable 폰트는 format이 다름
    const format = font.src.includes('.woff2') ? 'woff2' : 'truetype';
    const formatString = format === 'woff2' ? 'woff2' : 'truetype';
    
    const fontFace = new FontFace(
      font.family,
      `url(${font.src}) format('${formatString}')`,
      {
        weight: font.weight,
        style: font.style || 'normal',
        display: 'swap',
      }
    );

    fontFace.load().then((loadedFont) => {
      document.fonts.add(loadedFont);
    }).catch((error) => {
      console.error(`Failed to load font ${font.family} ${font.weight}:`, error);
    });
  });
};

export default loadFonts;

